module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-27.e2c46dcd.png";